import { render } from "./MmodelsIndex.vue?vue&type=template&id=583dbb17&scoped=true"
import script from "./MmodelsIndex.vue?vue&type=script&lang=js"
export * from "./MmodelsIndex.vue?vue&type=script&lang=js"

import "./MmodelsIndex.vue?vue&type=style&index=0&id=583dbb17&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\vrs_yii2_new\\vuejs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-583dbb17"]])

export default __exports__